<div class="panel__content no-padding">

  <div>
    <span>{{'Component Action Histroy'| translate | async}}</span>
  </div>
  <table class="table table--striped table--full-width">
    <thead>
      <tr>
        <th>{{'Date'| translate | async}}</th>
        <th>{{'SMU'| translate | async}}</th>
        <th>{{'Budget'| translate | async}}</th>
        <th>{{'CMU'| translate | async}}</th>
        <th>{{'% Worn'| translate | async}}</th>
        <th>{{'Residual'| translate | async}}</th>
        <th>{{'Cost'| translate | async}}</th>
        <!-- <th>{{'Rate'| translate | async}}</th> -->
        <th>{{'Action'| translate | async}}</th>
        <!-- <th>BCM</th>
        <th>Tonnage</th> -->
      </tr>
    </thead>
    <tbody>
      <tr class="table-row-style" *ngFor="let item of componentHistroy" > 
        <td>{{item.ActionDate |date: 'MMM dd yyyy'}}</td>
        <td>{{item.SMU}}</td>
        <td>{{item.Budget}}</td>
        <td>{{item.CMU}}</td>
        <td>{{item.Worn}}</td>
        <td>{{item.ResidualHrs}}</td>
        <td>{{item.cost}}</td>
        <td>{{item.ActionDesc}}</td>
      </tr>
    </tbody>


  </table>
</div>

<div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Close'| translate | async}}</button>
    
  </div>